import styled, { keyframes } from 'styled-components';

export const landingGreyBlack = '#2a2a2a';
export const landingFrameInset = '1rem';
export const landingFrameInsetTablet = '0.875rem';
export const landingFrameInsetMobile = '0.625rem';

const viewportBorderGlow = keyframes`
  0%, 100% {
    box-shadow:
      inset 0 0 0 1px rgba(255, 255, 255, 0.04),
      inset 0 0 1.75rem rgba(0, 0, 0, 0.7),
      inset 0 0 3.5rem rgba(0, 0, 0, 0.4),
      0 0 1.25rem rgba(0, 0, 0, 0.55);
  }
  50% {
    box-shadow:
      inset 0 0 0 1px rgba(255, 255, 255, 0.05),
      inset 0 0 2.5rem rgba(0, 0, 0, 0.9),
      inset 0 0 5rem rgba(0, 0, 0, 0.55),
      0 0 2rem rgba(0, 0, 0, 0.75);
  }
`;

export const LandingViewportFrame = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10;
  pointer-events: none;
  border: ${landingFrameInset} solid ${landingGreyBlack};
  box-sizing: border-box;
  animation: ${viewportBorderGlow} 3.2s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    box-shadow:
      inset 0 0 0 1px rgba(255, 255, 255, 0.04),
      inset 0 0 2rem rgba(0, 0, 0, 0.75),
      0 0 1.5rem rgba(0, 0, 0, 0.6);
  }

  @media (max-width: 1024px) {
    border-width: ${landingFrameInsetTablet};
  }

  @media (max-width: 640px) {
    border-width: ${landingFrameInsetMobile};
  }
`;

export const authPageBackground =
  'linear-gradient(180deg, #f2f4f3 0%, #eef8f6 100%)';

export const FramedPageShell = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: ${landingFrameInset};
  background: ${({ $light }) => ($light ? authPageBackground : landingGreyBlack)};
  position: relative;
  overflow-x: hidden;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    padding: ${landingFrameInsetTablet};
  }

  @media (max-width: 640px) {
    padding: ${landingFrameInsetMobile};
  }
`;
